import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useCallback,
  useImperativeHandle,
  useState,
} from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TiDeleteOutline } from "react-icons/ti";

import { PurchaseOrder } from "../../../../models/purchase.order";
import ConfirmationModal from "../../../Dialogs/ConfirmationModal";
import { Color } from "../../../Form/Button";
import useStyles from "./styles";

export interface RemovePurchaseOrderConfirmationModalHandles {
  open: (order: PurchaseOrder) => void;
  close: () => void;
}
interface RemovePurchaseOrderConfirmationModalProps {
  closeModal?: () => void;
  onSubmit: (id: number) => void;
  loadingAction?: boolean;
  title: string;
  from?: string;
  warningText?: string;
}

const RemovePurchaseOrderonfirmationModal: ForwardRefRenderFunction<
  RemovePurchaseOrderConfirmationModalHandles,
  RemovePurchaseOrderConfirmationModalProps
> = (props, ref) => {
  const classes = useStyles();
  const { closeModal, onSubmit, title, warningText, from } = props;
  const { t: translate } = useTranslation();

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [order, setOrder] = useState<PurchaseOrder>();

  const open = useCallback((order: PurchaseOrder) => {
    setOrder(order);
    setOpenModal(true);
  }, []);

  const close = useCallback(() => {
    setOrder(undefined);
    setOpenModal(false);
  }, []);

  useImperativeHandle(ref, () => ({
    open,
    close,
  }));

  return (
    <ConfirmationModal
      leftIconTitle={<TiDeleteOutline color="#F04438" className={classes.leftIcon} />}
      title={title}
      open={openModal}
      closeModal={() => {
        if (closeModal) closeModal();
        close();
      }}
      textCancel={translate("cancel")}
      textSubmit={translate("yesRemoveIt")}
      customColorSave={Color.ERROR}
      customColorCancel={Color.TEXT_INFO}
      submit={() => order?.id && onSubmit(order?.id)}
      type="error"
      className={classes.confirmModal}
    >
      <Grid container direction="column">
        <Grid item className={classes.confirmModalText}>
          <span>{translate("areYouSureYouWantToRemoveThe")}</span>{" "}
          <b>
            {translate("purchaseOrder")} {order?.reference || ""}
          </b>{" "}
          <span>{from}?</span>
        </Grid>
        <Grid item className={classes.confirmModalWarning}>
          <span>{warningText}.</span>
        </Grid>
      </Grid>
    </ConfirmationModal>
  );
};

export default forwardRef(RemovePurchaseOrderonfirmationModal);
